var cardGridMisc = (function () {
  
  return {
    init: init,
  };

  function init() {
    var cardGridMiscContainer = document.querySelectorAll(
      ".card-block-inter--misc"
    );
    var currentIndex = 0,
      cols = "";
    if (cardGridMiscContainer.length > 0) {
      Array.from(cardGridMiscContainer).forEach(function (container) {
        var row = container.querySelector(".card-block__row--misc");
        if (row != null) {
          cols = container.querySelectorAll(".card-block__col");

          if (cols.length > 0) {
            for (var i = 0; i < cols.length; i++) {
              cols[i].addEventListener("mouseenter", function (e) {
                currentIndex = Array.from(cols).indexOf(e.target);
                var direction = "right";
                if (e.target.classList.contains("card-block__col--slide-left")) {
                  direction = "left";
                }
                addTransition(currentIndex, direction);
              });

              cols[i].addEventListener("mouseleave", function (e) {
                for (var k = 0; k < cols.length; k++) {
                  cols[k].classList.remove("trasfromRight");
                  cols[k].classList.remove("trasfromLeft");
                }
              });
            }
          }
        }
      });

      function addTransition(currentIndex, direction) {
        for (var i = 0; i < cols.length; i++) {
          cols[i].classList.remove("trasfromRight");
          cols[i].classList.remove("trasfromLeft");
        }
        var length = 0;
        if (direction == "right") {
          if (currentIndex < 4) {
            length = 4;
          } else if (currentIndex > 5 && currentIndex < 8) {
            length = 8;
          } else if (currentIndex > 10 && currentIndex < 12) {
            length = 12;
          }
          var j = currentIndex + 1;

          for (j; j <= length; j++) {
            if( cols[j] != null){
              cols[j].classList.add("trasfromRight");
            }
          }
        } else {
          if (currentIndex == 4) {
            length = 1;
          } else if (currentIndex == 8) {
            length = 7;
          } else if (currentIndex == 12) {
            length = 11;
          }
          for (currentIndex; currentIndex >= length; currentIndex--) {
            if(cols[currentIndex - 2] != null){
              cols[currentIndex - 2].classList.add("trasfromLeft");
            }
          }
        }
      }
    }
  }
})();

document.addEventListener("DOMContentLoaded", function () {
  cardGridMisc.init();
});
